module.exports = __webpack_public_path__ + "public/srwrdsChest_Unlocked_tu.ogg";